import { makeStyles } from '@material-ui/core';
import { vSpacing } from 'src/common/helpers/config';
import { vh } from 'src/common/helpers/dimension-helper';

// Until the theme gets typed...
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const styles = makeStyles((theme: any) => ({
  middleButtonMenuContainer: {
    fontSize: vh(2.083),
    transform: `translate(-50%, ${vSpacing})`,
    marginRight: 'auto',
    width: '39.7vw',
    backgroundColor: theme.white,
    boxShadow: `1px 1px 11px ${theme.palette.info.main}`,
    outline: 0,
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontStretch: 'normal',
    fontStyle: 'normal',
    letterSpacing: '1.2px',
    borderTop: `3px solid ${theme.palette.secondary.main}`,
  },
  containerStyle: {
    marginLeft: '58.4vw',
    marginTop: '8.5vh',
    height: '80vh',
    '@media (max-width: 1600px)': {
      marginLeft: '57.3vw',
      width: '37.5vw',
    },
  },
  customerContainerStyle: {
    marginLeft: '51.3vw',
    marginTop: '10.5vh',
    height: '76.5vh',
  },
  iconStyle: {
    height: '3.5vh',
    width: '3.5vw',
    '@media (max-width: 1600px)': {
      height: '3.7vh',
      width: '3.7vw',
    },
    '@media (width: 1600px) and (height: 1200px)': {
      height: '3.5vh',
      width: '3.5vw',
    },
  },
}));
